import React from 'react';

const FilterIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_8268_6602)">
      <path d="M3.24143 8.07328H12.9021M0.922363 3.03125H15.2212M5.44676 13.1153H10.6968" stroke="#242424" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_8268_6602">
      <rect width="16" height="16" fill="white"/>
    </clipPath>
    </defs>
  </svg>
);

export default FilterIcon;
